<template>
  <div>
        <!--企业门店详情-->
        <div class="store">
            <div class="store-title">门店相册</div>
                <div  class="d-flex flex-wrap flex-padding">
                <div class="d-center-start w-50 mb-3">
                    <left-text leftText="门店外观"/>已上传<span @click="editStore('门店相册')" class="text-link ml-1 mr-1">{{storeInfo.pic.length||0}}</span>张
                </div>
                <div class="d-center-start w-50 mb-3" >
                    <left-text leftText="房型信息"/>已上传房型 <span @click="editStore('房型管理')" class="text-link ml-1 mr-1">{{storeInfo.room_arr.length||0}}</span>种
                </div>
                <div class="d-center-start w-50 mb-3" >
                    <left-text leftText="门店内景"/>已上传<span @click="editStore('门店相册')" class="text-link ml-1 mr-1" >{{storeInfo.pic_lobby.length||0}}</span>张
                </div>
                <div class="d-center-start w-50 mb-3" >
                    <left-text leftText="会议室信息"/>已上传会议室 <span @click="editStore('会议室管理')" class="text-link ml-1 mr-1" >{{storeInfo.meeting_arr.length}}</span>种
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'CorporateAlbum',
  components: {},
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    },
    store_id: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
        //编辑门店信息
      editStore(tab) {
        let routeUrl = this.$router.resolve({name:'StoreBasicInfo',query:{type:3,store:this.store_id,none:1,tab:tab}});
        window.open(routeUrl.href, '_blank');
      },
  }
};
</script>

<style lang="scss" scoped>
  .store{
        width: 100%;
        background-color: #fff;
        text-align: center;
        border-radius: 6px;
        text-align: left;
        margin-top: 20px;
        overflow: hidden;  
        box-shadow: 0px 0px 7px #eee;
    }
    .store-title{
        background-color: #f5f7fc;
        width: 100%;
        padding: 18px;
        color: #2e3949;
        font-size: 16px;
        font-weight: bold;
    }
    .flex-padding{
        padding: 18px;
        align-items: center;
    }
</style>
